import * as React from "react";

const InputMinusDisabled: React.FC = () => (
    <svg
        width="10px"
        height="1px"
        viewBox="0 0 10 1"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <polygon
            fill="currentColor"
            points="10 1 9.423 1 .577 1 0 1 0 0 .577 0 9.423 0 10 0"
            opacity=".33"
        />
    </svg>
);

export default React.memo(InputMinusDisabled);
